export default [
  {
    path: "/admin",
    name: "admin",
    component: () => import("./pages/admin/admin.component.vue"),
  },
  {
    path: "/admin/icons",
    name: "icons",
    component: () => import("./pages/admin/icons.component.vue"),
  },
  {
    path: "/admin/empty",
    name: "empty",
    component: () => import("./pages/admin/empty.component.vue"),
  },
  {
    path: "/admin/marketdata",
    name: "md",
    component: () => import("./pages/admin/marketdata.component.vue"),
  },
];
